// removed by extract-text-webpack-plugin
module.exports = {"base":"_2cGqn","table":"_3E2bo","sortable":"Q4Cyu","activeSort":"_15exw","ascending":"oJ7eu","descending":"_1mI19","unSortable":"s38iu","flushLeft":"_23JMa","flushRight":"_2ZX1l","flush":"_1cRQz","narrowRight":"_11ygz","narrowLeft":"_1oii3","narrowLeft10":"_3nxIb","narrowLeft20":"_2L7C8","narrow":"_1-cib","narrowHeight":"_2u6H9","narrowHeight10":"_3y-2_","rippleCell":"ekAfc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Table/Table.scss
// module id = 23
// module chunks = 0